<template>
  <div id="listaApertura">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Solicitudes de Apertura
          </h4>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title class="py-1">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
          >
          </v-text-field>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="aperturas"
          class="elevation-1"
          rows-per-page-text="Filas por página"
          no-data-text="No existen registros"
          no-results-text="Sin resultados"
          page-text="de"
          :rows-per-page-items="[10, 25, 50, 100, {'text': 'Todos', value: -1}]"
          v-bind:search="search"
          v-cloak
        >
          <template v-slot:items="props">
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.codigo }}</td>
            <td>CENTRO DE CAPACITACIÓN TÉCNICA {{ props.item.datos.institucional.nombre }}</td>
            <td>{{ props.item.datos.propietario.nombre }} {{ props.item.datos.propietario.paterno }} {{ props.item.datos.propietario.materno }}</td>
            <td>{{ props.item.datos.representante_legal.nombre }} {{ props.item.datos.representante_legal.paterno }} {{ props.item.datos.representante_legal.materno }}</td>
            <td>{{ props.item.fecha_registro | formatdate }}</td>
            <td align="center">
              <v-btn 
                depressed
                icon
                dark
                color="info"
                small
                @click="detailApertura(props.item.codigo, props.item.datos)"
                class="mx-1"
              >
                <v-icon small>view_list</v-icon>
              </v-btn>
              <v-btn                
                depressed
                icon
                dark
                color="success"
                small
                @click="confirmItem(props.item.id, props.item.datos)"
                class="mx-1"
              >
                <v-icon small>check</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog
      v-model="ddialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>Detalle de Solicitud de Apertura: {{ solicitud_codigo }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="ddialog = false">Cerrar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-lg fluid class="pa-0">
            <v-layout>
              <v-flex xs12 sm5>
                <v-card>
                  <v-card-text>
                    <h4 class="grey--text text--darken-3">Datos Institucionales</h4>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-text class="grey--text text--darken-1">
                    <div class="my-2">
                      <b>Centro: </b><span>CENTRO DE CAPACITACIÓN TÉCNICA {{ datos_apertura.institucional.nombre }}</span>
                    </div>
                    <div class="my-2">
                      <b>Sigla: </b><span>{{ datos_apertura.institucional.sigla }}</span>
                    </div>
                    <div class="my-2">
                      <b>Departamento: </b><span>{{ datos_apertura.institucional.departamento_nombre }}</span>
                    </div>
                    <div class="my-2">
                      <b>Provincia: </b><span>{{ datos_apertura.institucional.provincia_nombre }}</span>
                    </div>
                    <div class="my-2">
                      <b>Dirección: </b><span>{{ datos_apertura.institucional.direccion }}</span>
                    </div>
                  </v-card-text>
                </v-card><br>
                <v-card>
                  <v-card-text>
                    <h4 class="grey--text text--darken-3">Responsables del Centro de Capacitación</h4>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-text class="grey--text text--darken-1">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="grey lighten-4 py-1 px-1">
                          <h3 class="grey--text text--darken-1">Propietario</h3>
                        </v-card-title>
                        <div class="my-2">
                          <b>Nombres y Apellidos: </b><span>{{ datos_apertura.propietario.nombre }} {{ datos_apertura.propietario.paterno }} {{ datos_apertura.propietario.materno }}</span>
                        </div>
                        <div class="my-2">
                          <b>Cédula de Identidad: </b><span> {{ datos_apertura.propietario.cedula_identidad }} {{ datos_apertura.propietario.complemento }} {{ datos_apertura.propietario.expedido_nombre }}</span>
                        </div>
                        <div class="my-2">
                          <b>País: </b><span>{{ datos_apertura.propietario.pais_nombre }}</span>
                        </div>
                        <div class="my-2">
                          <b>Departamento: </b><span>{{ datos_apertura.propietario.departamento_nombre }}</span>
                        </div>
                        <div class="my-2">
                          <b>Dirección: </b><span>{{ datos_apertura.propietario.direccion }}</span>
                        </div>
                      </v-flex>
                      <v-flex xs12>
                        <v-card-title class="grey lighten-4 py-1 px-1">
                          <h3 class="grey--text text--darken-1">Representante Legal</h3>
                        </v-card-title>
                        <div class="my-2">
                          <b>Nombres y Apellidos: </b><span>{{ datos_apertura.representante_legal.nombre }} {{ datos_apertura.representante_legal.paterno }} {{ datos_apertura.representante_legal.materno }}</span>
                        </div>
                        <div class="my-2">
                          <b>Cédula de Identidad: </b><span> {{ datos_apertura.representante_legal.cedula_identidad }} {{ datos_apertura.representante_legal.complemento }} {{ datos_apertura.representante_legal.expedido_nombre }}</span>
                        </div>
                        <div class="my-2">
                          <b>País: </b><span>{{ datos_apertura.representante_legal.pais_nombre }}</span>
                        </div>
                        <div class="my-2">
                          <b>Departamento: </b><span>{{ datos_apertura.representante_legal.departamento_nombre }}</span>
                        </div>
                        <div class="my-2">
                          <b>Dirección: </b><span>{{ datos_apertura.representante_legal.direccion }}</span>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm7>
                <v-card>
                  <v-card-title>
                    <h4 class="grey--text text--darken-2">Socios</h4>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="pa-0">
                    <v-data-table
                      :headers="headerSocio"
                      :items="datos_apertura.socios"
                      class="elevation-1"
                      no-data-text="No existen registros"
                      hide-actions
                    >
                      <template v-slot:items="props">
                        <td>{{ props.index + 1 }}</td>
                        <td>{{ props.item.nombre }} {{ props.item.paterno }} {{ props.item.materno }}</td>
                        <td>{{ props.item.cedula_identidad }} {{ props.item.complemento }} {{ props.item.expedido_nombre }}</td>
                        <td>{{ props.item.pais_nombre }}</td>
                        <td>{{ props.item.departamento_nombre }}</td>
                        <td>{{ props.item.direccion }}</td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card><br>
                <v-card>
                  <v-card-title>
                    <h4 class="grey--text text--darken-2">Personal Administrativo</h4>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="pa-0">
                    <v-data-table
                      :headers="headerPersonalAdm"
                      :items="datos_apertura.personal_administrativo"
                      class="elevation-1"
                      no-data-text="No existen registros"
                      hide-actions
                    >
                      <template v-slot:items="props">
                        <td>{{ props.index + 1 }}</td>
                        <td>{{ props.item.nombre }} {{ props.item.paterno }} {{ props.item.materno }}</td>
                        <td>{{ props.item.cedula_identidad }} {{ props.item.complemento }} {{ props.item.expedido_nombre }}</td>
                        <td>{{ props.item.cargo_nombre }}</td>
                        <td>{{ props.item.formacion_profesional_nombre }}</td>
                        <td>{{ props.item.tipo_contrato }}</td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card><br>
                <v-card>
                  <v-card-title>
                    <h4 class="grey--text text--darken-2">Curso de Capacitación</h4>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="pa-0">
                    <v-data-table
                      :headers="headerCurso"
                      :items="datos_apertura.cursos_capacitacion"
                      class="elevation-1"
                      no-data-text="No existen registros"
                      hide-actions
                    >
                      <template v-slot:items="props">
                        <td>{{ props.index + 1 }}</td>
                        <td>{{ props.item.curso_nombre }}</td>
                        <td>{{ props.item.carga_horaria }}</td>
                        <td>{{ props.item.tiempo }}</td>
                        <td>
                          <v-btn-toggle>
                            <v-btn
                              v-if="props.item.turno_m"
                              small
                              class="transparent"
                            >
                              Mañana
                            </v-btn>
                            <v-btn
                              v-if="props.item.turno_t"
                              small
                              class="transparent"
                            >
                              Tarde
                            </v-btn>
                            <v-btn
                              v-if="props.item.turno_n"
                              small
                              class="transparent"
                            >
                              Noche
                            </v-btn>
                          </v-btn-toggle>
                        </td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card><br>
                <v-card>
                  <v-card-title>
                    <h4 class="grey--text text--darken-2">Facilitadores (por curso de capacitación)</h4>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="pa-0">
                    <v-data-table
                      :headers="headerFacilitador"
                      :items="datos_apertura.facilitadores"
                      class="elevation-1"
                      no-data-text="No existen registros"
                      hide-actions
                    >
                      <template v-slot:items="props">
                        <td>{{ props.index + 1 }}</td>
                        <td>{{ props.item.curso_nombre }}</td>
                        <td>{{ props.item.nombre }} {{ props.item.paterno }} {{ props.item.materno }}</td>
                        <td>{{ props.item.cargo_nombre }}</td>
                        <td>{{ props.item.formacion_profesional_nombre }}</td>
                        <td>{{ props.item.tipo_contrato }}</td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <!-- <div style="flex: 1 1 auto;"></div> -->
      </v-card>
    </v-dialog>
    <v-dialog v-model="cdialog" max-width="300px">
      <v-form ref="form">
        <v-card>
          <v-card-title class="headline grey lighten-3">
            <span class="headline">Alerta</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="text-xs-center">
            <span :class="color_txt + '--text text--darken-2 subheading'">
              {{ mensaje }}
            </span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="loadingUpdAdd" v-if="hide_accept" color="success darken-1" flat @click.native="updateSaveApertura">
              Aceptar
            </v-btn>
            <v-btn color="blue darken-1" flat @click.native="cdialog = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Service from '../services/general';
import axios from 'axios';
export default {
  name: 'lista-apertura',
  data() {
    return {
      search: '',
      headers: [
        { text: 'Nro', align: 'left', sortable: false, width: '50px' },
        { text: 'Código ', value: 'codigo' },
        { text: 'Centro ', value: 'datos.institucional.nombre' },
        { text: 'Propietario ', value: 'datos.propietario.nombre' },
        { text: 'Representante ', value: 'datos.representante_legal.nombre' },
        { text: 'Fecha ', value: 'fecha_registro' },
        { text: 'Acciones', align: 'center', sortable: false, width: '140px' }
      ],
      headerSocio: [
        { text: 'Nro', align: 'left', sortable: false, width: '50px' },
        { text: 'Nombres y Apellidos ', sortable: false },
        { text: 'Cédula de Identidad ', sortable: false },
        { text: 'País ', sortable: false },
        { text: 'Departamento ', sortable: false },
        { text: 'Dirección ', sortable: false }
      ],
      headerPersonalAdm: [
        { text: 'Nro', align: 'left', sortable: false, width: '50px' },
        { text: 'Nombres y Apellidos ', sortable: false },
        { text: 'Cédula de Identidad ', sortable: false },
        { text: 'Cargo ', sortable: false },
        { text: 'Formación Profesional ', sortable: false },
        { text: 'Tipo de Contrato ', sortable: false }
      ],
      headerFacilitador: [
        { text: 'Nro', align: 'left', sortable: false, width: '50px' },
        { text: 'Curso de Capacitación ', sortable: false },
        { text: 'Nombres y Apellidos ', sortable: false },
        { text: 'Cargo ', sortable: false },
        { text: 'Formación Profesional ', sortable: false },
        { text: 'Tipo de Contrato ', sortable: false }
      ],
      headerCurso: [
        { text: 'Nro', align: 'left', sortable: false, width: '50px' },
        { text: 'Curso de Capacitación ', sortable: false },
        { text: 'Carga Horaria ', sortable: false },
        { text: 'Tiempo (1 mes) ', sortable: false },
        { text: 'Turno (MTN) ', sortable: false }
      ],
      loading: false,
      loadingUpdAdd:  false,
      aperturas: [],
      solicitud_id: '',
      solicitud_codigo: '',
      datos_apertura: {
        institucioneducativa: '',
        tipo_contrato: [1],
        institucional: {},
        propietario: {},
        representante_legal: {},
        socios: [],
        personal_administrativo: [],
        cursos_capacitacion: [],
        facilitadores: [],
        requisito: [],
      },
      dparams: {},
      hide_accept: true,
      mensaje: '',
      ddialog: false,
      cdialog: false,
      color_txt: '',
      snack: {
        state: false,
        color: 'success',
        mode: '',
        text: ''
      }
    };
  },
  mounted() {
    this.dparams = Service.getParams();
    if (this.dparams && this.dparams.roluser != Service.rol().departamental) {
      this.$router.push({name: 'principal'});
    }
    if (this.dparams != null) {
      this.getAperturas();
    }
  },
  methods: {
    getAperturas() {
      this.loading = true;
      axios
        .get(Service.getBase() + 'lista/apertura/' + this.dparams.roluserlugarid, Service.getHeader())
        .then(response => {
          for (let index in response.data) {
            response.data[index].datos = JSON.parse(response.data[index].datos);
          }
          this.aperturas = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.error('Error al cargar registros', error);
        });
    },

    detailApertura(solicitud_codigo, datos) {
      this.solicitud_codigo = solicitud_codigo;
      this.datos_apertura = datos;
      this.ddialog = true;
    },

    confirmItem(solicitud_id, datos) {
      this.solicitud_id = solicitud_id;
      this.datos_apertura = datos;
      this.datos_apertura.institucioneducativa = '';
      this.datos_apertura.tipo_tramite = [1];
      this.color_txt = 'grey';
      this.mensaje = '¿Esta seguro(a) de confirmar la solicitud de Apertura, si acepta iniciará el trámite?';
      this.loadingUpdAdd = false;
      this.hide_accept = true;
      this.cdialog = true;
    },

    updateSaveApertura() {
      this.dparams.solicitud_id = this.solicitud_id;
      this.dparams.tramite_id = '';
      this.dparams.flujotipo_id = Service.getFlujoTipo().flujo_a;
      this.dparams.datos = JSON.stringify(this.datos_apertura);
      this.loadingUpdAdd = true;
      axios
        .post(Service.getBase() + 'inicio/apertura', this.dparams, Service.getHeader())
        .then(response => {
          this.loadingUpdAdd = false;
          if (response.data.estado == 200) {
            this.color_txt = 'success';
          } else {
            this.color_txt = 'error';
          }
          this.mensaje = response.data.msg;
          this.hide_accept = false;
          this.getAperturas();
        })
        .catch(error => {
          this.loadingUpdAdd = false;
          this.color_txt = 'error';
          this.mensaje = "No se pudo registrar la Solicitud de Apertura";
          console.error("Error al guardar", error);
        });
    },

    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
  }
};
</script>